module.exports = __webpack_public_path__ + "static/media/logo-tagline.813a0bd3.png";